import { Breadcrumbs } from '@mui/material';
import useEvent from 'providers/event/useEvent';
import { FormattedMessage } from 'react-intl';
import { Breadcrumb, BreadcrumbsContainer } from 'styles/styles';
import { useLocation } from 'wouter';

import { WaitingLineFormPages } from '../WaitingLineFormPages';

type WaitingLineFormBreadcrumbsProps = {
  currentPage: number;
  changeFormPage: (page?: number) => Promise<void>;
  updating: boolean;
};

export default function WaitingLineFormBreadcrumbs(props: WaitingLineFormBreadcrumbsProps) {
  const { currentPage, changeFormPage, updating } = props;
  const [, setLocation] = useLocation();
  const event = useEvent();

  return (
    <BreadcrumbsContainer>
      <Breadcrumbs separator="—">
        {event.hasWaitingLines && (
          <Breadcrumb
            $isClickable
            color="textSecondary"
            onClick={() => setLocation(`~/event/${event.id}/waitingLines`)}
          >
            <FormattedMessage id="waiting_lines" />
          </Breadcrumb>
        )}
        {!updating && (
          <Breadcrumb
            $isClickable
            color={currentPage === 0 ? 'secondary' : 'textSecondary'}
            onClick={() => changeFormPage(WaitingLineFormPages.TYPE_SELECTION)}
          >
            <FormattedMessage id="waiting_line_breadcrumb_select_type" />
          </Breadcrumb>
        )}
        <Breadcrumb
          $isClickable
          color={currentPage === 1 ? 'secondary' : 'textSecondary'}
          onClick={() => changeFormPage(WaitingLineFormPages.CONFIGURATION)}
        >
          <FormattedMessage id="waiting_line_breadcrumb_configuration" />
        </Breadcrumb>
        {event.languages.length > 1 && (
          <Breadcrumb
            $isClickable
            color={currentPage === 2 ? 'secondary' : 'textSecondary'}
            onClick={() => changeFormPage(WaitingLineFormPages.TRANSLATIONS)}
          >
            <FormattedMessage id="translations" />
          </Breadcrumb>
        )}
      </Breadcrumbs>
    </BreadcrumbsContainer>
  );
}
